import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Card,
  Text,
  Subtitle2,
} from '@fluentui/react-components';

export const SelectedCampaignsCard = ({ campaigns }) => {
  const i18n = useContext(I18nContext);
  const cardTitle = i18n.getString(_TL_('Campaigns'));
  const noContent = i18n.getString(_TL_('No campaigns selected'));
  const cardContent = campaigns.length === 0
    ? noContent
    : campaigns.map(({ name }) => name).join(i18n.getString(_TL_(', ')));

  return (
    <Card className="selected-campaigns-card">
      <Subtitle2>{cardTitle}</Subtitle2>
      <Text className="selected-campaigns">{cardContent}</Text>
    </Card>
  );
};

SelectedCampaignsCard.propTypes = {
  campaigns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
};
